<div *ngFor="let alert of alerts" class="alert-container">
    <ngb-alert [type]="alert.type" (closed)="close(alert)">
        {{ alert.message }}
    </ngb-alert>
</div>
